import Header from 'components/text/header';
import UseApi from 'hooks/useApi';
import { useState, useEffect } from 'react';
import Chart from 'react-apexcharts';

const BarChart = () => {
  const { getApi } = UseApi();
  const [bookings, setBookings] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res: any = await getApi(`admin-actions/bookings-month-count`);
      setBookings(res?.data?.data);
    };
    fetchData();
  }, []);
  const options = {
    chart: {
      id: 'bookings-bar',
    },
    xaxis: {
      categories: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'June',
        'July',
        'Aug',
        'Sep',
        'Nov',
        'Dec',
      ],
    },
  };
  const series = [
    {
      name: 'bookings',
      data: bookings,
    },
  ];

  return (
    <div>
      <Header extraClasses="my-4">Number of Bookings</Header>
      {bookings && (
        <Chart
          options={options}
          series={series}
          type="bar"
          className="mx-auto  w-full md:w-5/6  lg:w-3/4"
        />
      )}
    </div>
  );
};

export default BarChart;
